export default {"src":"/_next/static/media/stopwatch_40.e2bb85ee.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};